import { GzGeneralChartWebComponent } from './component/GzGeneralChartWebComponent';

export { GzGeneralChartWebComponent };
